import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import AboutYourApplicationPage from './AboutYourApplicationPage';
import { dataCaptureSelectors, redirectToInitialPage } from '../../store/dataCapture';
import { ABOUT_YOUR_APPLICATION_PAGE_INFO } from '../../utils/constants';
import * as analytics from '../../utils/analytics';

class AboutYourApplicationSection extends Component {
  render() {
    const { bankId, brandId, redirectToInitialPage, getBusinessData, productName } = this.props;
    analytics.updateApplicant();
    return (
      <AboutYourApplicationPage
        brandId={brandId}
        bankId={bankId}
        productName={productName}
        saveApplicationCompleteForm={redirectToInitialPage}
        getBusinessData={getBusinessData}
      />
    );
  }
}

AboutYourApplicationSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  redirectToInitialPage: PropTypes.func.isRequired
};

const actionCreators = {
  redirectToInitialPage
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  productName: selectors.getProductName(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, ABOUT_YOUR_APPLICATION_PAGE_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AboutYourApplicationSection);
